import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate, substractDays, compareAsc } from 'datesHelper.js';
import {
  changeDateByType,
  changeActiveTab,
  fetchTransactionsByFilter,
  setCurrentPage,
  resetToInitialState,
} from 'accountWalletActions.js';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import S from 'StyledAccountWallet.js';

class AccountWallet extends Component {
  state = {
    transactions: [],
  };

  componentDidMount = async () => {
    const datePickers = document.getElementsByClassName('react-datepicker__input-container');
    Array.from(datePickers).forEach((el) => el.childNodes[0].setAttribute('readOnly', true));

    const { fetchTransactionsByFilter } = this.props;
    try {
      await fetchTransactionsByFilter();
    } catch (error) {
      console.log('fetchTransactionsByFilter:' + error);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.isPending != this.props.isPending &&
      !this.props.isPending &&
      this.props.data.length
    ) {
      this.prepeareStateFromTransations(this.props.data);
    }
  }

  componentWillUnmount = () => {
    const { resetToInitialState } = this.props;
    resetToInitialState();
  }

  handleRedirectToPaymentCancel = (id, amount, date) => {
    app.router.redirect('/payoutCancel/:transactionId/:amount/:date', {
      transactionId: id,
      amount,
      date,
    });
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchTransactionsByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchTransactionsByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchTransactionsByFilter();
    });
  };

  prepeareStateFromTransations = (data) => {
    const transactions = data.map(({ transactionId }) => {
      const item = {
        transactionId,
        isOpen: false,
      };
      return item;
    });

    this.setState((prevState) => {
      const nextState = {
        transactions,
      };
      return nextState;
    });
  };

  findItemByTransactionId = (searchId) => {
    return this.state.transactions.find(({ transactionId }) => transactionId == searchId);
  };

  updateTransactionItem = (indexOfItem, item) => {
    this.setState((prevState) => {
      const itemsBeforeIndex = prevState.transactions.slice(0, indexOfItem);
      const itemsAfterIndex = prevState.transactions.slice(indexOfItem + 1);
      const nextState = {
        ...prevState,
        transactions: [...itemsBeforeIndex, { ...item, isOpen: !item.isOpen }, ...itemsAfterIndex],
      };
      return nextState;
    });
  };

  getTransactionStatusClass = (statusCode) => {
    const status = statusCode.toUpperCase();
    switch (status) {
      case 'DEC':
      case 'FLD':
      case 'ERR':
        return 'red';
      case 'SCS':
        return 'green';
      case 'IPR':
      case 'INI':
        return 'gray';
      default:
        return '';
    }
  };

  parseStatus = (status) => {
    return 'transfer_statusList.' + status;
  };

  parseType = (type) => {
    return 'transferTypeList.' + type;
  };

  goPage = (currentPage) => {
    const { fetchTransactionsByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchTransactionsByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountWallet.goPage');
    }
  };

  setStartDate = (days) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const today = new Date();
    const startDate = substractDays(today, days);
    const endDate = days === 1 ? startDate : today;

    batch(() => {
      changeDateByType('startDate', startDate);
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  compareDates = (dateLeft, dateRight) => {
    dateLeft = new Date(formatDate(dateLeft, 'yyyy-MM-dd'));
    dateRight = new Date(formatDate(dateRight, 'yyyy-MM-dd'));
    const result = compareAsc(dateLeft, dateRight);

    if (!result) {
      return true;
    }
    return false;
  };

  render() {
    const { isPending, activeTab, currentPage, limit, data, isNextPageAvailable, startDate, endDate } = this.props;

    return (
      <S.AccountWallet>
        <S.WalletFilters>
          <S.WalletFiltersTop>
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, 'all')}
              isActive={activeTab === 'all'}
            >
              {translation('account_wallet_types_all')}
            </S.FilterBtn>

            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, 'deposit')}
              isActive={activeTab === 'deposit'}
            >
              {translation('account_wallet_types_deposits')}
            </S.FilterBtn>
            <S.FilterBtn
              onClick={this.onChangeFilter.bind(this, 'payout')}
              isActive={activeTab === 'payout'}
            >
              {translation('account_wallet_types_payouts')}
            </S.FilterBtn>
          </S.WalletFiltersTop>
          <S.WalletFiltersDates>
            <S.DateLabel>
              <div className="select-date"> {translation('account_wallet_selectDate')}</div>
              <div className="select-date"> {translation('account_wallet_selectDate')}</div>
            </S.DateLabel>

            <S.Datepicker>
              <input
                type="date"
                value={formatDate(startDate, 'yyyy-MM-dd')}
                onChange={(event) => this.handleChangeStart(event.target.value)}
              />
            </S.Datepicker>
            <S.Datepicker>
              <input
                type="date"
                value={formatDate(endDate, 'yyyy-MM-dd')}
                onChange={(event) => this.handleChangeEnd(event.target.value)}
              />
            </S.Datepicker>
          </S.WalletFiltersDates>
        </S.WalletFilters>
        <S.WalletTransactions className="wallet-transaction-list">
          {isPending ? (
            <Loader />
          ) : (
            <>
              <S.WalletTransactionsList className="transaction-list">
                <S.FakeTableBody>
                  {data.map(
                    ({
                      amount,
                      regDate,
                      type,
                      statusCode,
                      transactionId,
                      currencyCode,
                      referenceId,
                    }) => {
                      const translationItem = this.findItemByTransactionId(transactionId);
                      const { isOpen } = translationItem || false;
                      let date = formatDate(regDate, 'dd-MM-yyyy HH:mm').split(' ');
                      let dateWithHours = [
                        ...date[0],
                        translation('account_wallet_shortHour'),
                        ...date[1],
                      ].join('');
                      let isTransactionCancelable = type == 156 && statusCode == 'INI';
                      return (
                        <S.WalletTransactionsListItemWrapper key={transactionId}>
                          <S.WalletTransactionsListItem className="transaction-list-item">
                            <div className="wallet-id">
                              <span>{transactionId}</span>
                            </div>
                            <div className="wallet-date">
                              <span>{dateWithHours}</span>
                            </div>
                          </S.WalletTransactionsListItem>

                          <S.WalletTransactionsListItemDetails isOpen={isOpen}>
                            <S.ItemDetailsBox>
                              <S.ItemDetailsHeader>
                                {translation('account_wallet_transfers_status')}
                              </S.ItemDetailsHeader>
                              <S.ItemDetailsBody
                                className={`wallet-status ${this.getTransactionStatusClass(
                                  statusCode
                                )}`}
                              >
                                <div className="status-icon"></div>
                              </S.ItemDetailsBody>
                            </S.ItemDetailsBox>
                            <S.Divider />

                            <S.ItemDetailsBox>
                              <S.ItemDetailsHeader>
                                {translation('account_wallet_transfers_type')}
                              </S.ItemDetailsHeader>
                              <S.ItemDetailsBody>
                                {translation(this.parseType(type))}
                              </S.ItemDetailsBody>
                            </S.ItemDetailsBox>
                            <S.Divider />

                            <S.ItemDetailsBox>
                              <S.ItemDetailsHeader>
                                {translation('account_wallet_transfers_description')}
                              </S.ItemDetailsHeader>
                              <S.ItemDetailsBody
                                className={this.getTransactionStatusClass(statusCode)}
                              >
                                {translation(this.parseStatus(statusCode))}
                              </S.ItemDetailsBody>
                            </S.ItemDetailsBox>
                            <S.Divider />
                            <S.ItemDetailsBox>
                              <S.ItemDetailsHeader>
                                {translation('account_wallet_transfers_amount')}
                              </S.ItemDetailsHeader>
                              <S.ItemDetailsBody>
                                {formatMoney(amount)} {currencyCode === 'PLN' ? 'zł' : currencyCode}
                              </S.ItemDetailsBody>
                            </S.ItemDetailsBox>
                            <S.Divider />

                            <S.ItemDetailsBox>
                              <S.ItemDetailsHeader>
                                {translation('account_wallet_transfers_transferNumber')}
                              </S.ItemDetailsHeader>
                              <S.ItemDetailsBody> {transactionId}</S.ItemDetailsBody>
                            </S.ItemDetailsBox>
                            <S.ItemDetailsBox>
                              <S.PayoutCancelButton
                                onClick={() =>
                                  this.handleRedirectToPaymentCancel(referenceId, amount, regDate)
                                }
                                disabled={!isTransactionCancelable}
                                className={`${
                                  isTransactionCancelable ? 'available' : 'not-available'
                                }`}
                              >
                                {isTransactionCancelable
                                  ? translation('Anuluj wypłatę')
                                  : translation('Niedostępne')}
                              </S.PayoutCancelButton>
                            </S.ItemDetailsBox>
                          </S.WalletTransactionsListItemDetails>
                        </S.WalletTransactionsListItemWrapper>
                      );
                    }
                  )}
                </S.FakeTableBody>

                {!data.length ? (
                  <S.NoResult className="no-result">
                    {translation('account_wallet_transfers_notFound')}
                  </S.NoResult>
                ) : null}
              </S.WalletTransactionsList>

              {data.length > 0 ? (
                <Pagination
                  {...{ currentPage, limit, data, isNextPageAvailable, callback: this.goPage }}
                />
              ) : null}
            </>
          )}
        </S.WalletTransactions>
      </S.AccountWallet>
    );
  }
}

const mapStateToProps = (
  {
    AccountWallet: {
      isPending,
      error,
      startDate,
      endDate,
      activeTab,
      data,
      isNextPageAvailable,
      currentPage,
      limit,
    },
  },
  props
) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    data,
    currentPage,
    limit,
    isNextPageAvailable
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchTransactionsByFilter: bindActionCreators(fetchTransactionsByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    resetToInitialState: bindActionCreators(resetToInitialState, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountWallet);
